export default "__VITE_ASSET__BLQPx1Is__"